module.exports = __webpack_public_path__ + "static/media/icon_confirmation_yellow.f7001b88.svg";